var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.314 16.5751L12.9249 12.2561C14.0743 11.0074 14.7805 9.35588 14.7805 7.53858C14.7799 3.65103 11.5779 0.5 7.62764 0.5C3.6774 0.5 0.475342 3.65103 0.475342 7.53858C0.475342 11.4261 3.6774 14.5772 7.62764 14.5772C9.33442 14.5772 10.8998 13.9868 12.1295 13.0053L16.5356 17.3414C16.7503 17.5529 17.0988 17.5529 17.3135 17.3414C17.5287 17.1299 17.5287 16.7866 17.314 16.5751ZM7.62764 13.4942C4.28531 13.4942 1.57582 10.8278 1.57582 7.53858C1.57582 4.24935 4.28531 1.58293 7.62764 1.58293C10.97 1.58293 13.6795 4.24935 13.6795 7.53858C13.6795 10.8278 10.97 13.4942 7.62764 13.4942Z",
    fill: "#017E89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b7931b67c723d7138eb3da8344b6eefa.svg";
export { ForwardRef as ReactComponent };